export const detectTrainingListIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete training list" || cleaned === "remove training list") {
        return { intent: "delete_training_list" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) training list/);
    if (deleteMatch) {
        return { intent: "delete_training_list", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create training list") || cleaned.includes("add training list")) {
        return { intent: "create_training_list" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create training list named (.+)/);
    if (createMatch) {
        return { intent: "create_training_list", name: createMatch[1].trim() };
    }

    return null;
};
